import request from '@/api/request';

export function checkPhone (phoneNumber) {
  return request({
    url: '/account/checkphone',
    method: 'get',
    params: { phoneNumber }
  });
}

export function checkEmail (email) {
  return request({
    url: '/account/checkemail',
    method: 'get',
    params: { email }
  });
}

export function register (data) {
  return request({
    url: '/account/register',
    method: 'post',
    data
  });
}

export function getAccesstokenZalo (params) {
  return request({
    url: '/user/accesstokenZalo',
    method: 'get',
    params
  });
}

export function updateProfile (data) {
  return request({
    url: '/user/profile',
    method: 'put',
    data
  });
}

export function changePassword (data) {
  return request({
    url: '/user/changepassword',
    method: 'put',
    data
  });
}

export function requestOtp (data) {
  return request({
    url: '/user/requestotp',
    method: 'post',
    data
  });
}

export function checkOtp (data) {
  return request({
    url: '/user/checkotp',
    method: 'post',
    data
  });
}

export function forgotPassword (data) {
  return request({
    url: '/user/forgotpassword',
    method: 'post',
    data
  });
}

export function registerFirebaseToken (token) {
  let data = {
    token
  };
  return request({
    url: '/firebase/token/register',
    method: 'post',
    data
  });
}

export function removeFirebaseToken (token) {
  let data = {
    token
  };
  return request({
    url: '/firebase/token/remove',
    method: 'post',
    data
  });
}

export function loginFacebook (data) {
  return request({
    url: '/user/loginfacebook',
    method: 'post',
    data
  });
}

export function loginGoogle (data) {
  return request({
    url: '/user/logingoogle',
    method: 'post',
    data
  });
}

export function loginZalo (data) {
  return request({
    url: '/user/loginzalo',
    method: 'post',
    data
  });
}

export function linkToFacebook (data) {
  return request({
    url: '/user/linktofacebook',
    method: 'post',
    data
  });
}

export function linkToGoogle (data) {
  return request({
    url: '/user/linktogoogle',
    method: 'post',
    data
  });
}

export function linkToZalo (data) {
  return request({
    url: '/user/linktozalo',
    method: 'post',
    data
  });
}

export function cancelThirdParty (data) {
  return request({
    url: '/user/CancelThirdParty',
    method: 'post',
    data
  });
}


// WEBPACK FOOTER //
// ./src/api/user.js